import CustomLayout from '../../../../components/CustomLayout'
import Reader from '../../../../components/reader/Reader'
import {callApiFromServer} from '../../../../helpers/Api';
import {updateCloudinaryUrl} from '../../../../helpers/Cloudinary';

function Read({story, storyUuid, storyVersion, ...props}) {
    return (
        <CustomLayout
            title={story.title}
            description={story.description}
            image={story.cover ? updateCloudinaryUrl(story.cover) : null} 
            showFooter={false}
        >
            <Reader
                storyUuid={storyUuid}
                storyVersion={storyVersion}
                editing={false} 
            />
        </CustomLayout>
    )
}

// This gets called on every request
export async function getServerSideProps(context) {
    const {params} = context;

    if( !params || !params.storyUuid || !params.storyVersion) {
        context.res.writeHead(302, { Location: '/404' });
        context.res.end();
    }

    const data = await callApiFromServer(context, '/api/story/book/' + params.storyUuid)

    if(!data || data.length === 0) {
        context.res.writeHead(302, { Location: '/404' });
        context.res.end();
    }
    
    return { props: { story: data[0], storyUuid: params.storyUuid, storyVersion: params.storyVersion} }
}

export default Read;